import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {AnimatedTextLatter} from "../styles/AnimationText";

const SectionTitleStyle = styled.div`
  text-align: center;

  p {
    font-family: 'RobotoMono Regular', sans-serif;
    font-size: 2rem;
    padding: 10px;
  }


  h2 {
    font-family: 'Montserrat Bold', sans-serif;
    font-size: 6rem;
    margin-top: 0.5rem;
    text-transform: uppercase;
    color: var(--gray-3) !important;
  }


  @media only screen and (max-width: 768px) {
    text-align: center;
    p {
      font-size: 1.2rem;
    }

    h2 {
      font-size: 3.6rem;
    }
  }
  @media only screen and (max-width: 375px) {
    text-align: center;
    p {
      font-size: 1.6rem;
    }

    h2 {
      font-size: 3.6rem;
    }
  }
`;

const SectionTitle =
    ({
         subheading = 'Need Subheading',
         heading = ['S', 'E', 'R', 'V', 'I', 'C', 'E', 'S'],
     }) => {

        const [letterClass, setLetterClass] = useState('text-animate')


        useEffect(() => {
            try {
                let animation = setTimeout(() => {
                    setLetterClass('text-animate-hover')
                }, 4000)
                return () => {
                    clearTimeout(animation);
                }
            } catch (error) {
                console.log(error)
            }
        }, [])

        return (
            <SectionTitleStyle className="section-title">
                <p>{subheading}</p>
                {/*<h2>{heading}</h2>*/}
                <AnimatedTextLatter
                    letterClass={letterClass}
                    strArray={heading}
                    idx={22}
                />
            </SectionTitleStyle>
        );
    }

export default React.memo(SectionTitle)
